

import {
  FETCH_DESIGNATIONS_REQUEST,
  FETCH_DESIGNATIONS_SUCCESS,
  FETCH_DESIGNATIONS_FAILURE,
  CREATE_DESIGNATION_REQUEST,
  CREATE_DESIGNATION_SUCCESS,
  CREATE_DESIGNATION_FAILURE,
} from "../actions/designationActions";

const initialState = {
  designations: [],
  loading: false,
  creating: false,
  error: null,
};

const designationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DESIGNATIONS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_DESIGNATIONS_SUCCESS:
      return { ...state, loading: false, designations: action.payload };
    case FETCH_DESIGNATIONS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CREATE_DESIGNATION_REQUEST:
      return { ...state, creating: true, error: null };
    case CREATE_DESIGNATION_SUCCESS:
      return {
        ...state,
        creating: false,
        designations: [...state.designations, action.payload.name],
      };
    case CREATE_DESIGNATION_FAILURE:
      return { ...state, creating: false, error: action.payload };

    default:
      return state;
  }
};

export default designationReducer;


// import {
//   FETCH_DESIGNATIONS_REQUEST,
//   FETCH_DESIGNATIONS_SUCCESS,
//   FETCH_DESIGNATIONS_FAILURE,
//   CREATE_DESIGNATION_REQUEST,
//   CREATE_DESIGNATION_SUCCESS,
//   CREATE_DESIGNATION_FAILURE,
//   FETCH_ADMIN_DESIGNATIONS_REQUEST,
//   FETCH_ADMIN_DESIGNATIONS_SUCCESS,
//   FETCH_ADMIN_DESIGNATIONS_FAILURE,
//   UPDATE_DESIGNATION_REQUEST,
//   UPDATE_DESIGNATION_SUCCESS,
//   UPDATE_DESIGNATION_FAILURE,
// } from "../actions/designationActions";

// const initialState = {
//   designations: [],
//   adminDesignations: [],
//   loading: false,
//   loadingAdmin: false,
//   creating: false,
//   updating: false,
//   error: null,
// };

// const designationReducer = (state = initialState, action) => {
//   switch (action.type) {
//     // NORMAL EMPLOYEE DESIGNATIONS
//     case FETCH_DESIGNATIONS_REQUEST:
//       return { ...state, loading: true, error: null };

//     case FETCH_DESIGNATIONS_SUCCESS:
//       return { ...state, loading: false, designations: action.payload };

//     case FETCH_DESIGNATIONS_FAILURE:
//       return { ...state, loading: false, error: action.payload };

//     // CREATE DESIGNATION
//     case CREATE_DESIGNATION_REQUEST:
//       return { ...state, creating: true, error: null };

//     case CREATE_DESIGNATION_SUCCESS:
//       return {
//         ...state,
//         creating: false,
//         designations: [...state.designations, action.payload?.name],
//       };

//     case CREATE_DESIGNATION_FAILURE:
//       return { ...state, creating: false, error: action.payload };

//     // ADMIN DESIGNATIONS
//     case FETCH_ADMIN_DESIGNATIONS_REQUEST:
//       return { ...state, loadingAdmin: true, error: null };

//     case FETCH_ADMIN_DESIGNATIONS_SUCCESS:
//       return { ...state, loadingAdmin: false, adminDesignations: action.payload };

//     case FETCH_ADMIN_DESIGNATIONS_FAILURE:
//       return { ...state, loadingAdmin: false, error: action.payload };

//     // UPDATE DESIGNATION
//     case UPDATE_DESIGNATION_REQUEST:
//       return { ...state, updating: true, error: null };

//     case UPDATE_DESIGNATION_SUCCESS:
//       return { ...state, updating: false };

//     case UPDATE_DESIGNATION_FAILURE:
//       return { ...state, updating: false, error: action.payload };

//     default:
//       return state;
//   }
// };

// export default designationReducer;
